import React from 'react';
import Textarea from 'react-textarea-autosize';

import type { MemoryDataForm } from '../../types/forms/memorydataform';

interface MemoryAboutProps {
  memoryData: MemoryDataForm;
  register: Function;
};

const MemorySprkMessage: React.FC<MemoryAboutProps> = ({ memoryData, register }) => {
  return (
    <div className="memory-about-container inner">
      <div className="memory-about-header">
        <div className="page-eyebrow">
          <wa-avatar initials="3" />
          Your message
        </div>
      </div>
      <div className="memory-about wa-stack">
        <div className="wa-grid">
          <div className="memory-about-title">
            <label htmlFor="title">Title (optional)</label>
            <wa-input
              id="title"
              type="text"
              defaultValue={memoryData.title}
              {...register('title')}
            />
          </div>
        </div>
        <div className="wa-grid">
          <div className="memory-about-content">
            <label htmlFor="content">Your message</label>
            <Textarea
              id="content"
              minRows={3}
              {...register('content')}
              defaultValue={memoryData.content}
              placeholder="Keep it short and honest - a sentence or two is perfect."
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemorySprkMessage;
